import { Typography } from 'antd';
import { ChapterState } from '../../../../../../../../../../lib/models/TemplateTypes';
import { useVariables } from 'src/processes/CMS/processes/management/pages/PreviewPage/hooks/useVariables';
import styles from './styles.module.scss';
import { ArrowRight } from '../../../../../../../../../../ui/icons/ArrowRight';
import { getDisplayedProduct } from '../FirstChapter/utils';
import { getChapterIconUrl } from '../../../../../../utils/rules/chapters_rules_engine_helper';
import { CircleIconNew } from '../../../../../../../../../../ui/icons/CircleIconNew';
import { TwoIcon } from '../../../../../../../../../../ui/icons/TwoIcon';
import { ThreeIcon } from '../../../../../../../../../../ui/icons/ThreeIcon';
import { FourIcon } from '../../../../../../../../../../ui/icons/FourIcon';
import { isHeadlineOnImageHidden } from './utils';

// eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
export function PreviewNotFirstChapter({
  chapter,
  style,
  colors,
  fonts,
  chapterIconMedia,
  chapterOnClick,
  pagesFlow,
  chapterIndex,
  animationPhase,
  imageSelectionFlow,
}) {
  const { applyVariable } = useVariables(pagesFlow);
  const { currentChapterId } = pagesFlow;

  const { otherChaptersStyle = {} } = style;

  const {
    content,
    content: { headline, selectChapterIcon } = {},
    state,
    flow,
    chapterInnerPagesIds,
    id: chapterId,
    resultSelectedProducts,
    rules,
  } = chapter;

  const displayedProduct = getDisplayedProduct(resultSelectedProducts, content?.productsPriority);
  const chapterIconUrl = getChapterIconUrl(chapterId, imageSelectionFlow, selectChapterIcon, chapterIconMedia);

  const isChapterFinished = displayedProduct || state === ChapterState.COMPLETED;

  const isBorderAnimation = animationPhase === 'border';
  const isImageAnimation = animationPhase === 'image';

  const shouldShowImage = (displayedProduct || isImageAnimation) && chapterIconUrl;
  const shouldShowHeadlineOnImage = shouldShowImage && !isHeadlineOnImageHidden(pagesFlow);
  const hasOrangeBorder = isBorderAnimation || (state === ChapterState.OPENED && currentChapterId === chapterId);

  const handleClick = () => {
    if (state === ChapterState.NOT_OPENED) return;
    chapterOnClick(chapterId, flow, rules, state, chapterInnerPagesIds[0], chapterIndex);
  };

  const getChapterIndexIcon = () => {
    // eslint-disable-next-line no-magic-numbers
    if (chapterIndex === 2) return <TwoIcon width={38} height={54} />;
    // eslint-disable-next-line no-magic-numbers
    if (chapterIndex === 3) return <ThreeIcon width={38} height={54} />;
    // eslint-disable-next-line no-magic-numbers
    if (chapterIndex === 4) return <FourIcon width={38} height={54} />;
    return null;
  };

  return (
    <div
      tabIndex={state === ChapterState.NOT_OPENED ? undefined : 0}
      className={`${styles.card} ${isBorderAnimation ? styles.cardBorderAnimation : ''}`}
      role='button'
      onClick={handleClick}
      onKeyDown={event => {
        if (event.key === 'Enter' && state !== ChapterState.NOT_OPENED) {
          handleClick();
        }
      }}
      style={{
        border: hasOrangeBorder ? '3px solid rgba(255, 102, 0, 1)' : 'none',
        boxShadow: '2px 5px 19px 0px #00000082 inset',
        pointerEvents: state === ChapterState.NOT_OPENED && 'none',
        cursor: [ChapterState.COMPLETED, ChapterState.OPENED].includes(state) ? 'pointer' : 'default',
        borderRadius: '8px',
        background: '#fff',
        ...otherChaptersStyle,
      }}
    >
      <div className={`${styles.frame} ${shouldShowImage ? styles.frameWithImage : ''}`}>
        {shouldShowImage && (
          <img
            className={`${styles.frameImg} ${isImageAnimation ? styles.frameImgAnimation : ''}`}
            src={chapterIconUrl}
            alt='Chapter'
            draggable={false}
          />
        )}

        <div className={styles.content}>
          {!isImageAnimation && (!isChapterFinished || !displayedProduct) && (
            <div className={styles.circleWrapper}>
              <span>{getChapterIndexIcon()}</span>
              <CircleIconNew width={125} height={125} />
            </div>
          )}

          {!isImageAnimation && state === ChapterState.COMPLETED && (!isChapterFinished || !displayedProduct) && (
            <p
              className={styles.headlinePlaceholder}
              style={{
                fontFamily: fonts.headlineThird.font,
                fontSize: '24px',
                color: '#B3B3B3',
                fontWeight: '700',
                marginBottom: 0,
              }}
            >
              {applyVariable(headline?.value)}
            </p>
          )}

          {shouldShowHeadlineOnImage && (
            <p
              className={styles.headlineOnImage}
              style={{
                fontFamily: fonts.headlineThird.font,
                fontSize: '24px',
                fontWeight: '700',
              }}
            >
              {applyVariable(headline?.value)}
            </p>
          )}

          {(state === ChapterState.OPENED || hasOrangeBorder) && !isImageAnimation ? (
            <button
              type='button'
              className={styles.buttonGoTo}
              style={{
                backgroundColor: colors.primaryColor,
                fontWeight: 700,
                fontSize: fonts.headlineFourth.fontSize,
                fontFamily: fonts.headlineFourth.font,
              }}
            >
              {applyVariable(headline.value)}
              <ArrowRight />
            </button>
          ) : (
            headline &&
            !isChapterFinished &&
            !isImageAnimation && (
              <Typography.Paragraph
                className={styles.headlineTitle}
                style={{
                  fontFamily: fonts.headlineThird.font,
                  fontSize: '24px',
                  color: '#B3B3B3',
                  fontWeight: '700',
                  marginBottom: 0,
                  marginTop: 10,
                }}
              >
                {applyVariable(headline?.value)}
              </Typography.Paragraph>
            )
          )}
        </div>
      </div>
    </div>
  );
}
